import{normalizeArraysPath}from"../validate/path.js";
import{validateEmptyQuery,validateQueryString}from"../validate/string.js";

import{parseQueryString}from"./query.js";



export const parsePath=(pathString)=>{
const queryArrays=parseQuery(pathString);
return normalizeArraysPath(queryArrays,pathString)
};


export const parseQuery=(queryString)=>{
validateQueryString(queryString);
const queryArrays=parseQueryString(queryString);
validateEmptyQuery(queryArrays,queryString);
return queryArrays
};